import { fixture } from './fixtures.js';

export const money = (value) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
export const date = (value) => new Intl.DateTimeFormat('de-DE').format(new Date(`${value}T12:00:00Z`));
export const lineNet = (line) => Number((line.quantity * line.unitNet).toFixed(2));
export const documentTotals = (lines, vatRate = 0.19) => {
  const net = Number(lines.reduce((sum, line) => sum + lineNet(line), 0).toFixed(2));
  const vat = Number((net * vatRate).toFixed(2));
  return { net, vat, gross: Number((net + vat).toFixed(2)) };
};

export function record(type, id) {
  return recordIn(fixture, type, id);
}

function recordIn(data, type, id) {
  const map = { customer: 'customers', proposal: 'proposals', order: 'orders', invoice: 'invoices' };
  return map[type] ? data[map[type]].find((item) => item.id === id) ?? null : null;
}

export function linesFor(document, data = fixture) {
  if (document.lines) return document.lines;
  const source = data.proposals.find((item) => item.id === document.linesFrom);
  return source?.lines ?? [];
}

export function elbChain(data = fixture) {
  const customer = recordIn(data, 'customer', 'C-1001');
  const proposal = recordIn(data, 'proposal', 'AN-2026-1001');
  const order = recordIn(data, 'order', proposal?.orderId);
  const invoice = recordIn(data, 'invoice', order?.invoiceId);
  if (!customer || !proposal || !order || !invoice) return null;
  const valid = proposal.customerId === customer.id && order.customerId === customer.id && invoice.customerId === customer.id && order.proposalId === proposal.id && invoice.orderId === order.id && proposal.orderId === order.id && order.invoiceId === invoice.id && linesFor(order, data) === proposal.lines && linesFor(invoice, data) === proposal.lines;
  return valid ? { customer, proposal, order, invoice, totals: documentTotals(proposal.lines) } : null;
}

export function dashboardCounts() {
  return {
    offers: fixture.proposals.filter(({ status }) => ['Nicht versendet', 'Angenommen'].includes(status)).length,
    orders: fixture.orders.length,
    invoices: fixture.invoices.filter(({ status }) => status === 'Nicht versendet').length,
    warnings: fixture.materials.filter((item) => item.quantity < item.minimum).length,
  };
}

export function verifyFixture(data = fixture) {
  const ids = new Set();
  for (const group of [data.customers, data.proposals, data.orders, data.invoices]) {
    for (const item of group) {
      if (ids.has(item.id)) return false;
      ids.add(item.id);
    }
  }
  const chain = elbChain(data);
  if (!chain) return false;
  const due = new Date(`${chain.invoice.dueDate}T12:00:00Z`);
  const issued = new Date(`${chain.invoice.date}T12:00:00Z`);
  return (due - issued) / 86400000 === chain.invoice.paymentTermDays && chain.invoice.paymentTermDays === 14 && chain.totals.net === 1139 && chain.totals.vat === 216.41 && chain.totals.gross === 1355.41;
}
